import WorkOrderList from "../../work_order/work_order_list";

const TASKS_CONFIG = {
  pageTitle: "Tasks",
  documentTitle: "Tasks - RueBaRue",
  showCreateButton: false,
  showFilters: false,
  showPropertyManagerFilter: true,
  showCSVExport: false,
  showTags: false,
  showDelete: false,
  showEdit: "owner_only", // only owners can edit; assignees see comment only
  urlSync: false,
  fetchTags: false,
  extraCriteria: { my_tasks: "true" },
  editModuleKey: "operations.tasks",
  taskTypeLabel: "Type*",
};

const Tasks = () => <WorkOrderList config={TASKS_CONFIG} />;

export default Tasks;
